import { siteName, tagline } from '../config/site.js';

export default function Home() {
  return (
    <section className="page-content">
      <h1><em>{tagline}</em></h1>
      {/* <hr /> */}
      <p>
        Welcome to <strong>{siteName}</strong> — an open creative space where{' '}
        <em>{tagline}</em>.
      </p>
      <p>
        This is a place for music, ideas, and the stories behind the sounds. Whether you're
        here for the releases, the projects, or simply the feeling — you belong here.
      </p>
      <p>
        Explore our music, discover the projects that shape our sound, and connect with the
        community that makes it all possible.
      </p>
      <p>
        Music is at the heart of everything we do at WAABM. From ambient explorations to
        collaborative compositions, every piece reflects a unique perspective brought to life
        through sound.
      </p>
      <p>
        Browse our releases across SoundCloud, Bandcamp, and streaming platforms. Each release
        is an invitation to listen closely — and to find something of yourself in the notes.
      </p>
      <p>Good music doesn't have an expiration date!</p>
    </section>
  );
}
